import { render, staticRenderFns } from "./LoanAmountTransactionHistoryComponent.vue?vue&type=template&id=57239f6f&"
import script from "./LoanAmountTransactionHistoryComponent.vue?vue&type=script&lang=js&"
export * from "./LoanAmountTransactionHistoryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports